import { FC, FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import BackNextButtons from 'components/BackNextButtons';
import DeliveryAddress from 'components/forms/DeliveryAddress/USA';
import HomeAddress from 'components/forms/HomeAddress/UsaHomeAddress';
import PersonalInfo from 'components/forms/PersonalInfo/SSN';
import RealNameInfo from 'components/forms/RealNameInfo';
import Toast from 'components/Toast';
import { useCheckUSAPostal } from 'hooks/useCheckPostal';
import { IdTypeEnum, NameTypeEnum } from 'types/customer';
import { reportEventList } from 'utils/gtag';
import withProgressForm, { ProgressFormProps } from 'utils/withProgressForm';
import styles from './style.scss';

const BaseInfo: FC<ProgressFormProps> = ({ onSubmit, $formutil }) => {
    const navigate = useNavigate();
    const { checkPostalMatchStateCodeError } = useCheckUSAPostal();
    const { $params } = $formutil;

    const handleSubmit = (ev: FormEvent) => {
        onSubmit(async () => {
            Toast.loading(true);

            try {
                const homePostalError = await checkPostalMatchStateCodeError(
                    'home_postal',
                    'home_state_code',
                    'home_address_type'
                );
                const deliveryPostalError = await checkPostalMatchStateCodeError(
                    'delivery_postal',
                    'delivery_state_code',
                    'delivery_address_type'
                );

                if (!homePostalError && !deliveryPostalError) {
                    reportEventList('personalInfo');

                    navigate('../job');
                }
            } catch (err) {
                Toast.show(err);
            }

            Toast.loading(false);
        }, ev);
    };

    return (
        <form className={styles.root} noValidate onSubmit={handleSubmit}>
            <h3 className="open-title">{__('PERSONAL INFORMATION')}</h3>
            <RealNameInfo nameType={NameTypeEnum.USA} />
            <PersonalInfo
                idNumberProps={{
                    source: 'esop',
                    maskIdNo: null,
                    idType: IdTypeEnum.SSN_IDS
                }}
            />
            <h3 className="open-title">
                {__('RESIDENTIAL ADDRESS')}
                <p className={styles.tips}>
                    * {__('A PO Box can be used as a mailing address, but not residential address')}
                </p>
            </h3>
            <HomeAddress />
            {$params.same_delivery_and_residence === '0' && <DeliveryAddress isSSN isMarsco countryDisabled />}
            <BackNextButtons />
        </form>
    );
};

export default withProgressForm({
    step: 1,
    id: 'baseinfo',
    basePath: 'esop'
})(BaseInfo);
